<template>
  <div
    class="changed-box"
    :class="{ active }" />
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false
    }
  }

}
</script>

<style lang="scss" scoped>
.changed-box {
  width: 8px;
  height: 24px;
  background-color: $grey14;

  &.active {
    background-color: $pink;
  }
}

</style>